export default __webpack_public_path__ + "images/540bb78e9238863339a19c1588ef29f8-pop_music.jpg";